import * as React from "react"
import { Box } from "@mui/material"
import { usePricingChangeForm } from "../../@hooks"
import { ActionButton } from "@components"


export default function CreateReportButton() {
    const { handleOpenForm, isLoadingDrawer } = usePricingChangeForm()

    return <Box componet="span" data-tour="pricing-changes-create-report">
        <ActionButton
            isLoading={isLoadingDrawer}
            label="Create New Report"
            icon="pen-to-square"
            onClick={handleOpenForm}
        />
    </Box>
}